import { render } from "./UserInfo.vue?vue&type=template&id=a4868a2e&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=a4868a2e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\54574\\Desktop\\07_临时文件\\桌面文件夹\\Metro数据后台\\data_dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4868a2e"]])

export default __exports__